import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-6 md:py-10 px-4" data-id="element-291">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-292">
        <div className="flex flex-col items-center justify-center" data-id="element-293">
          <UsersIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-294" />
          <span className="text-3xl font-black mb-1" data-id="element-295">+600</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-296">
            docentes
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-297">
          <BookOpenIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-298" />
          <span className="text-3xl font-black mb-1" data-id="element-299">7</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-300">
            Tomos listos
            <br data-id="element-301" />
            Edición 2026
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-302">
          <div className="flex text-yellow-400 mb-3" data-id="element-303">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-304" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-305" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-306" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-307" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-308" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-309">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-310">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-311">
          <MapPinIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-312" />
          <span className="text-3xl font-black mb-1" data-id="element-313">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-314">
            Todo el país
            <br data-id="element-315" />
            1° a 6° año
          </span>
        </div>
      </div>
    </section>;
}